import React from "react";
import { motion } from "framer-motion";
import "../ContactPage/Contact.css";
import msg_icon from "../assets/msg-icon.png";
import mail_icon from "../assets/mail.png";
import phone_icon from "../assets/phone.png";
import white_arrow from "../assets/white-arrow.png";

export default function Contact() {
  const [result, setResult] = React.useState("");

  const onSubmit = async (event) => {
    event.preventDefault();
    setResult("Sending....");
    const formData = new FormData(event.target);

    formData.append("access_key", "9a5427e5-e0cb-42cc-beac-7c3695c652a1");

    const response = await fetch("https://api.web3forms.com/submit", {
      method: "POST",
      body: formData,
    });

    const data = await response.json();

    if (data.success) {
      setResult("Form Submitted Successfully");
      event.target.reset();
    } else {
      console.log("Error", data);
      setResult(data.message);
    }
  };

  return (
    <div className="contact-container">
      <motion.h2
        className="contact-name"
        initial={{ opacity: 0, y: -50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
      >
        Contact Us
      </motion.h2>

      <motion.h1
        className="contact-sub"
        initial={{ scale: 0.8 }}
        animate={{ scale: 1 }}
        transition={{ duration: 0.8 }}
      >
        Get in Touch
      </motion.h1>

      <div className="contact">
        {/* Left Column */}
        <motion.div
          className="contact-col"
          whileHover={{ rotateY: 10, rotateX: 10 }}
          transition={{ type: "spring", stiffness: 200 }}
        >
          <h3>
            Send us a message <img src={msg_icon} alt="" />
          </h3><br />

          <ul>
           <li>
  <img
    src={mail_icon}
    alt="Mail"
    style={{
      width: "80px",
      height: "60px",
      marginRight: "10px",
      verticalAlign: "middle",
    }}
  />
  <span>digitalignite43@gmail.com</span>
</li><br />
            <li>
              <img 
               style={{
      width: "80px",
      height: "60px",
      marginRight: "10px",
      verticalAlign: "middle",
    }}
              src={phone_icon} alt="" /> +91 8527472989
            </li>
        
          </ul>
        </motion.div>

        {/* Right Column */}
        <motion.div
          className="contact-col"
          whileHover={{ rotateY: -10, rotateX: -10 }}
          transition={{ type: "spring", stiffness: 200 }}
        >
          <motion.form
            onSubmit={onSubmit}
            initial={{ opacity: 0, x: 50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
          >
            <label>Your Name</label>
            <input type="text" name="name" placeholder="Enter your name " required />
            <label>Phone Number</label>
            <input
              type="tel"
              name="phone"
              placeholder="Enter your phone number "
              required
            />
            <label>Write your message here</label>
            <textarea
              name="message"
              rows="6"
              placeholder="Enter your message"
              required
            ></textarea>
            <button type="submit" className="btn dark-btn">
              Submit now <img src={white_arrow} alt="" />
            </button>
          </motion.form>
          <span>{result}</span>
        </motion.div>
      </div>
    </div>
  );
}
